"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateReportingOutputXlsxConfig = exports.validateFileInsertionConfig = exports.isBankAccountNeedForFileType = exports.isLoanProductNeededForFileType = exports.isArtifactSlugNeededForFileType = exports.validateDataCellObjectConfig = void 0;
const common_1 = require("@finley-technologies/common");
const finley_types_1 = require("@finley-technologies/finley-types");
const validateDataCellObjectConfig = (config) => {
    const { data } = config;
    const errors = [];
    const seenCellAddress = new Set();
    for (const { value, excelCoordinate } of data) {
        // Check for duplicate cell addresses
        if (seenCellAddress.has(excelCoordinate)) {
            errors.push(`Duplicate cell address: ${excelCoordinate}`);
        }
        else {
            seenCellAddress.add(excelCoordinate);
        }
        // Check for proper cell address
        if (excelCoordinate.length === 0) {
            errors.push(`Can not save empty Cell Address`);
        }
        else if (!common_1.utils.isProperExcelCoords(excelCoordinate)) {
            errors.push(`Improper cell address: ${excelCoordinate}`);
        }
        // Check for proper value input
        if (value === '' || value === null || value === undefined) {
            errors.push('Can not provide empty value');
        }
    }
    return errors;
};
exports.validateDataCellObjectConfig = validateDataCellObjectConfig;
const ArtifactSlugNeededFileTypes = [
    'rawSupplementalTape',
    'generatedSupplementalTape',
];
const isArtifactSlugNeededForFileType = (fileType) => {
    return ArtifactSlugNeededFileTypes.includes(fileType);
};
exports.isArtifactSlugNeededForFileType = isArtifactSlugNeededForFileType;
const FileInsertionTypeWithoutLoanProduct = [
    'borrowingBaseReserve',
    'rawSupplementalTape',
    'generatedSupplementalTape',
    'statementDailySummary',
    'bankAccountScreenshot',
];
const isLoanProductNeededForFileType = (fileType) => {
    return !FileInsertionTypeWithoutLoanProduct.includes(fileType);
};
exports.isLoanProductNeededForFileType = isLoanProductNeededForFileType;
const BankAccountNeededFileTypes = [
    'bankAccountScreenshot',
];
const isBankAccountNeedForFileType = (fileType) => {
    return BankAccountNeededFileTypes.includes(fileType);
};
exports.isBankAccountNeedForFileType = isBankAccountNeedForFileType;
const validateFileInsertionConfig = (config) => {
    const { fileType, loanProductId, reportingDateFormula, startingExcelCoordinate, artifactSlug, } = config;
    const errors = [];
    if (!finley_types_1.CreditAgreement.Config.Reporting.Outputs.Xlsx.FileInsertionTypeIterable.includes(fileType)) {
        errors.push(`Can not saved unsupported file type: ${fileType}`);
    }
    if ((0, exports.isLoanProductNeededForFileType)(fileType)) {
        if (!loanProductId) {
            errors.push(`Can not save empty Loan Product for file type: ${fileType}`);
        }
    }
    if (!reportingDateFormula) {
        errors.push(`Can not save empty Reporting Date formula`);
    }
    if (startingExcelCoordinate.length === 0) {
        errors.push(`Can not save empty Excel Coordinate`);
    }
    else if (!common_1.utils.isProperExcelCoords(startingExcelCoordinate)) {
        errors.push(`Improper Excel Coordinate: ${startingExcelCoordinate}`);
    }
    if ((0, exports.isArtifactSlugNeededForFileType)(fileType)) {
        if (!artifactSlug) {
            errors.push(`Artifact slug is needed for "${fileType}" file type`);
        }
    }
    return errors;
};
exports.validateFileInsertionConfig = validateFileInsertionConfig;
const validateReportingOutputXlsxSheet = (params) => {
    const { type, config } = params.sheet;
    switch (type) {
        case 'dataCellObject':
            return (0, exports.validateDataCellObjectConfig)(config);
        case 'imageFileInsertion':
        case 'fileInsertion':
            return (0, exports.validateFileInsertionConfig)(config);
        default:
            return (0, common_1.finleyAssertUnreachable)(type);
    }
};
const validateReportingOutputXlsxConfig = (params) => {
    const { name, sheets } = params.config;
    const errors = [];
    if (name.length === 0) {
        errors.push(`Reporting output name can not be empty`);
    }
    const seenSheetName = new Set();
    for (const sheet of sheets) {
        const { name: sheetName } = sheet;
        if (seenSheetName.has(sheetName)) {
            errors.push(`Detected duplicate Reporting output sheet name [name:${sheetName}]`);
        }
        else {
            seenSheetName.add(sheetName);
        }
        const sheetErrors = validateReportingOutputXlsxSheet({ sheet });
        sheetErrors.forEach((err) => errors.push(err));
    }
    return errors;
};
exports.validateReportingOutputXlsxConfig = validateReportingOutputXlsxConfig;
//# sourceMappingURL=outputXlsxConfigValidate.js.map